import React from 'react';
import { render } from '@testing-library/react';
import { TextArea } from './TextArea';

describe('TextArea', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<TextArea
				defaultValue="Value is already set."
				placeholder="Placeholder"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
